// extracted by mini-css-extract-plugin
module.exports = {"number":"number--bL2AZ"};